import endpoints from 'constants/endpoints';
import {
  SET_NOTIFICATIONS,
  SET_PUSH_NOTIFICATIONS_AND_POP_UPS,
  SET_POP_UP
} from 'constants/types';
import {
  notificationsObjectFactory,
  popUpFactory
} from 'helpers/factory/notificationFactory';
import { safePostCall } from 'helpers/firebaseSetup';

export const getNotifications = () => (dispatch, getState) => {
  let notifications = getState().notifications.notifications;
  if (!(Object.keys(notifications).length > 0)) {
    safePostCall(endpoints.awsProxy.safePost, {
      endpoint: endpoints.zoho.getNotifications,
      isZohoRequest: true
    })
      .then(notificationsRes => {
        // bail only when the whole details envelope is missing (actual failure).
        // when it exists but output is "" (no notifications), we still need to
        // fall through so the empty-state branch dispatches { empty: 'Empty' }.
        if (!notificationsRes?.data?.details) return;
        const output = notificationsRes.data.details.output || '';
        notificationsRes = JSON.parse(`[${output}]`);
        if (notificationsRes.length > 0)
          dispatch({
            type: SET_NOTIFICATIONS,
            payload: notificationsObjectFactory(notificationsRes)
          });
        else
          dispatch({
            type: SET_NOTIFICATIONS,
            payload: { empty: 'Empty' }
          });
      })
      .catch(error => {
        console.error(error);
      });
  }
};

function mergeByDate(notifications, popUps) {
  const normalizedNotifications = notifications.map(n => ({
    ...n,
    type: 'notification',
    date: new Date(n.sent_at)
  }));

  const normalizedPopups = popUps.map(p => ({
    ...p,
    type: 'pop-up',
    date: new Date(p.start_date)
  }));

  const merged = [...normalizedNotifications, ...normalizedPopups];

  merged.sort((a, b) => b.date - a.date);

  return merged;
}

export const getPushNotificationsAndPopUps =
  () => async (dispatch, getState) => {
    const state = getState();
    const pushNotificationsAndPopUps =
      state.notifications.push_notifications_and_pop_ups;
    const zohoId = state.user.zohoData.id;

    let notifications = [];
    let popUps = [];

    if (!pushNotificationsAndPopUps && zohoId) {
      try {
        const notificationsRes = await safePostCall(
          endpoints.awsProxy.safePost,
          {
            endpoint: endpoints.zoho.getPushNotifications,
            isWeb: true,
            isMobile: false,
            agentId: zohoId,
            isZohoRequest: true
          }
        );

        if (notificationsRes?.data?.details?.output) {
          const data = JSON.parse(notificationsRes.data.details.output);
          notifications = data?.notifications || [];
        }

        const popUpsRes = await safePostCall(endpoints.awsProxy.safePost, {
          endpoint: endpoints.zoho.getPopUps,
          agentId: zohoId,
          isZohoRequest: true
        });

        if (popUpsRes?.data?.details?.output) {
          popUps = JSON.parse(popUpsRes.data.details.output);
          popUps = (popUps || [])
            .map(popUp => popUpFactory(popUp) || null)
            .filter(Boolean);
        }

        dispatch({
          type: SET_PUSH_NOTIFICATIONS_AND_POP_UPS,
          payload: mergeByDate(notifications, popUps)
        });
      } catch (err) {
        console.error(err);
        dispatch({
          type: SET_PUSH_NOTIFICATIONS_AND_POP_UPS,
          payload: []
        });
      }
    }
  };

export const getPopUp = () => (dispatch, getState) => {
  const pop_up = getState().notifications.pop_up;

  if (!pop_up && getState().user.zohoData.id) {
    safePostCall(endpoints.awsProxy.safePost, {
      endpoint: endpoints.zoho.getPopUp,
      agentId: getState().user.zohoData.id,
      isZohoRequest: true
    })
      .then(res => {
        if (!res?.data?.details?.output) return;
        const data = JSON.parse(res.data.details.output);

        const popUp = popUpFactory(data) || null;

        if (popUp) {
          // set the pop up in the redux store
          dispatch({
            type: SET_POP_UP,
            payload: popUp
          });
        }
      })
      .catch(err => {
        console.error(err);
        dispatch({
          type: SET_POP_UP,
          payload: null
        });
      });
  }
};

export const getLimitedUserPopUp = () => dispatch => {
  dispatch({
    type: SET_POP_UP,
    payload: {
      id: 'inactive-user-pop-up',
      type: 'pop-up',
      danger: true,
      size: 'medium',
      content: {
        title: 'Warning',
        subtitle: 'Your portal access is limited right now',
        body: "<p>It looks like your account is currently limited, so some portal features (including carrier appointments) are hidden.</p><p>Want full access back? Contact our team and we'll help you reactivate.</p><p><strong>Email:</strong> support@oneillmarketing.net</p><p><strong>Call:</strong> (813) 489-4156</p>",
        image_url: null
      },
      background: {
        border_radius: '0px',
        image_url: 'none',
        image_fit: 'cover',
        image_position: 'center',
        color: '#fff',
        opacity: 1
      },
      show_primary_button: false,
      show_secondary_button: false,
      show_dismiss_button: true,
      primary_button: {
        label: null,
        type: null,
        url: null,
        path: null,
        is_external: false
      },
      secondary_button: {
        label: null,
        type: null,
        url: null,
        path: null,
        is_external: false
      },
      dont_show_again_checkbox: false,
      start_date: new Date()
    }
  });
};
